module.exports = __webpack_public_path__ + "img/10.4bb76679.webp";